let lastScrollTop = 0;

const onScroll = () => {
    setMaxWidthProperty ();
    shrinkHeaderOnScroll ();
    getScrollDirection ();
}

const getScrollDirection = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop) {
        document.body.classList.remove('scrolling-up')
        document.body.classList.add('scrolling-down')
    } else {
        document.body.classList.remove('scrolling-down')
        document.body.classList.add('scrolling-up')
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
}
const setMaxWidthProperty = () => {
    const isLargeScreen = window.innerWidth > 768;
    let maxWidth = isLargeScreen ? 50 : 95;
    const userBelowScrollOffset = window?.pageYOffset > 32;
    if (userBelowScrollOffset && maxWidth < 100) {
        let num = (window.pageYOffset / 60) * (isLargeScreen ? 1 : -1);
        maxWidth = parseFloat(num + maxWidth);
        if (isLargeScreen) {
            document.documentElement.style.setProperty("--maxWidth", `${maxWidth}%`);
        } else {
            document.documentElement.style.setProperty("--mobileMaxWidth", `${maxWidth}%`);
        }
        document.documentElement.style.setProperty("--blur", `${parseInt(window.pageYOffset / 80) + 0.5}px`);
    }
}
const shrinkHeaderOnScroll = () => {
    if (window.innerWidth > 375) {
        const headerLogo = document.querySelector('header .logo');
        const userBelowScrollOffset = window?.pageYOffset > 32;
        const isMobile = window.innerWidth < 768;
        if (userBelowScrollOffset) {
                headerLogo.style.width = '161px';
        } else {
            headerLogo.style.width = isMobile ? '161px' : '200px';
        }
    }
    
}
const newsletterLogic = () => {
    const newsletterContainer = document.getElementById('main-newsletter');
    const newsletterHasBeenSeen = localStorage.getItem('newsletter-engaged');
    const newsletterCloseButton = document.getElementById('newsletter-close');
    if (!newsletterHasBeenSeen && newsletterContainer) newsletterContainer.style.transform = 'translateY(0)';
    newsletterCloseButton.addEventListener('click', () => {
        newsletterContainer.style.transform = 'translateY(100%)';
        localStorage.setItem('newsletter-engaged', 'yes');
    });
}



document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('scroll', onScroll, { passive: true });

    setTimeout(() => {
        newsletterLogic ();
    }, 4000);
})

// CSS SALES TEAM LOGIC
document.addEventListener("DOMContentLoaded", () => {

    const MAX_ATTEMPTS = 20;

    const enableCartBtn = () => {
        let adcBtn = document.querySelector('.adc-btn');
        if (adcBtn) adcBtn.disabled = false;
    }

    const configureSalesRepBtn = () => {
        let accountBtn = document.getElementById('account-btn');
        if (accountBtn) {
            accountBtn.innerText = 'Sales Rep Portal';
            accountBtn.setAttribute('title', "Sales Rep Portal");
            accountBtn.setAttribute('aria-label', 'Sales Rep Portal');
            accountBtn.setAttribute('href', '/pages/rep-login');
        }
    }

    const authenticateUser = () => {
        console.log('🔐 — LETS AUTHENTICATE USER!')
        document.body.classList.remove('not-logged-in');
        document.body.classList.add('sales-rep-logged-in')
        enableCartBtn ();
        configureSalesRepBtn ();
    }

    const waitForSalesTeamProps = () => {
        let attempts = 0;
        const interval = setInterval(() => {
            if (window?.SalesTeamSlideCartProps?.SalesRepObject?.CustomerId) {
                console.log('✅ Sales Rep detected!');
                clearInterval(interval); // clear before calling
                authenticateUser();
                
            } else if (attempts >= MAX_ATTEMPTS) {
                console.log('⏭️ No Sales Rep - continuing as regular customer');
                clearInterval(interval);
            }
            attempts++;
        }, 300);
    }

    waitForSalesTeamProps ();

})